import { render, staticRenderFns } from "./PropostaFileUpload.vue?vue&type=template&id=75132dc5&scoped=true"
import script from "./PropostaFileUpload.vue?vue&type=script&lang=js"
export * from "./PropostaFileUpload.vue?vue&type=script&lang=js"
import style0 from "./PropostaFileUpload.vue?vue&type=style&index=0&id=75132dc5&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75132dc5",
  null
  
)

export default component.exports